import { Routes, Route, Navigate } from "react-router-dom";

import { entities } from "byzantine";
import { useBreakpoints, Row } from "@narmi/design_system";

import AlertNavBar from "./AlertsNavBar";
import AlertsMobileNav from "./AlertsMobileNav";
import AlertPage from "../AlertPage";
import SecurityAlerts from "../SecurityAlerts";
import CustomAlerts from "../CustomAlerts";

import styles from "./AlertsContainer.module.scss";

const AlertsContainer = () => {
  const { m } = useBreakpoints();
  const accounts = entities.accounts.useAccounts();

  return (
    <Row className={styles.container} alignItems={m ? "top" : "center"}>
      {m ? <AlertNavBar /> : <AlertsMobileNav />}
      <Routes>
        {["", "balance"].map((path) => (
          <Route
            key={path}
            path={path}
            element={<AlertPage pageKey="balance-alerts" accounts={accounts} />}
          />
        ))}
        <Route
          path="spending"
          element={<AlertPage pageKey="spending-alerts" accounts={accounts} />}
        />
        <Route path="security" element={<SecurityAlerts />} />
        <Route
          path="custom"
          element={
          <div className={styles.advancedAlertsContainer}>
            <CustomAlerts accounts={accounts} />
          </div>
          }
        />
        <Route path="*" element={<Navigate to="" />} />
      </Routes>
    </Row>
  );
};

export default AlertsContainer;
